import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElConfigProvider } from 'element-plus';
import zhLocale from 'element-plus/es/locale/lang/zh-cn';
import enLocale from 'element-plus/es/locale/lang/en';
import { computed } from 'vue';
import { useSettingStore } from '@/stores/setting';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const locale = computed(() => {
  const settingStore = useSettingStore();
  const langeState: string = settingStore.lang;
  return (langeState === 'zh' || langeState === 'zh-cn') ? zhLocale : enLocale;
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(ElConfigProvider), { locale: _unref(locale) }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})